import create from 'zustand'

export type SceneErrorState = {
  errorMessage: string | null
  setErrorMessage: (message: string) => void
  clearErrorMessage: () => void
}

export const useSceneErrorStore = create<SceneErrorState>(set => ({
  errorMessage: null,
  setErrorMessage: (message: string) => set({ errorMessage: message }),
  clearErrorMessage: () => set({ errorMessage: null }),
}))
